import axios from "axios";
import swal from "sweetalert";
import appConfig from "../../../Config/applicationEnv";

const getLoginUrl = () => {
  const base = appConfig.BASE_URL || "https://apipostman.onlinecu.in/";
  return base.replace(/\/$/, "") + "/exam_sch/api/login";
};

export const LoginManual = async (user_email, user_password) => {
  try {
    const data = {
      user_email,
      password: user_password,
    };

    const apiResponse = await axios({
      method: "post",
      url: getLoginUrl(),
      data,
    });

    if (apiResponse?.status === 200) {
      const userRole = apiResponse?.data?.user_role_id;
      
      // First, store all data in localStorage BEFORE redirecting
      let localStorageObj = {
        accessToken: apiResponse?.data?.access,
        roleId: apiResponse?.data?.user_role_id,
        userId: apiResponse?.data?.user_id,
        userName: apiResponse?.data?.user_name,
      };
      localStorage.setItem("slotbook", JSON.stringify(localStorageObj));

      // Combined logic for storing admin/student data based on role
      if (userRole === 1 || userRole === 2) {
        localStorage.setItem("adminData", JSON.stringify(apiResponse?.data));
      } else {
        localStorage.setItem("studentData", JSON.stringify(apiResponse?.data));
      }

      sessionStorage.setItem(
        "loginNotification",
        JSON.stringify({
          message: "Login Successful",
          description: "Welcome back!",
        })
      );

      // Now handle redirects based on role
      // Use setTimeout to ensure localStorage is fully written before redirect
      setTimeout(() => {
        if (userRole === 1) {
          window.location.href = "/";
        } else if (userRole === 2) {
          window.location.href = "/email";
        } else {
          swal({
            title: "Access Denied",
            text: "You do not have permission to access this Page.",
            icon: "error",
            button: "Close",
          });
        }
      }, 100);
    }

    if (
      apiResponse?.data?.access === null ||
      apiResponse?.data?.access === undefined ||
      apiResponse?.data?.access === ""
    ) {
      localStorage.clear();
      window.location.href = "/login";
    }
  } catch (error) {
    swal({
      title: `${error.response?.data?.message || "Something went wrong."}`,
      text: "Something went wrong.",
      icon: "warning",
      button: "Close",
    });
  }
};

const checkLoggedIn = () => {
  const localStorageObj = JSON.parse(localStorage.getItem("slotbook"));
  if (!localStorageObj || !localStorageObj.accessToken) {
    if (window.location.pathname !== "/login") {
      window.location.href = "/login";
    }
  }
};

checkLoggedIn();
